/**
 * @packageDocumentation
 * @module HackerAPI.Event.Faq
 */
import { __extends } from "tslib";
import Base from "../../base/base";
import { parseDate } from "../../utils/utils";
import HackerAPIFetch from "../../hackerapi-fetch/hackerapi-fetch";
/**
 * A data container for a FAQ related to an event
 * @class
 * @extends { HackerAPI.Base }
 */
var Faq = /** @class */ (function (_super) {
    __extends(Faq, _super);
    /**
     * Creates a new faq
     * @constructor
     * @param faq
     */
    function Faq(_a) {
        var _b = _a === void 0 ? {} : _a, id = _b.id, question = _b.question, answer = _b.answer, category = _b.category, links = _b.links, created_at = _b.created_at, createdAt = _b.createdAt, updated_at = _b.updated_at, updatedAt = _b.updatedAt;
        var _this = _super.call(this) || this;
        /**
         * The faq id
         * @type { number }
         */
        _this.id = id;
        /**
         * The question
         * @type { string }
         */
        _this.question = question;
        /**
         * The answer
         * @type { string }
         */
        _this.answer = answer;
        /**
         * What category the question falls into
         * @type { string }
         */
        _this.category = category;
        /**
         * Helpful links
         * @type { string[] }
         */
        _this.links = links;
        /**
         * When the faq was created
         * @type { Date }
         */
        _this.createdAt = parseDate(created_at || createdAt);
        /**
         * When the faq was last updated
         * @type { Date }
         */
        _this.updatedAt = parseDate(updated_at || updatedAt);
        return _this;
    }
    /**
     * Gets the faqs for an event
     * @param event - The event to get the faqs for
     * @param event.slug
     * @returns The faqs
     */
    Faq.fetchAll = function (_a) {
        var slug = _a.slug;
        return HackerAPIFetch({
            path: "/v2/events/" + slug + "/faq",
            method: "GET"
        }).then(function (data) { return data.map(function (datum) { return new Faq(datum); }); });
    };
    /**
     * Adds a faq to an event
     * @param event - The event the faq is for
     * @param event.slug
     * @param faq - The faq to add
     * @param token
     * @returns The added faq
     */
    Faq.create = function (_a, faq, token) {
        var slug = _a.slug;
        return HackerAPIFetch({
            path: "/v2/events/" + slug + "/faq",
            method: "POST",
            body: faq.toHackerAPIFormat(),
            token: token
        }).then(function (data) { return new Faq(data); });
    };
    /**
     * Updates a faq
     * @param event - The event the faq is for
     * @param event.slug
     * @param faq - The faq to update
     * @param token
     * @returns The updated faq
     */
    Faq.updateFaq = function (_a, faq, token) {
        var slug = _a.slug;
        return HackerAPIFetch({
            path: "/v2/events/" + slug + "/faq/" + faq.id,
            method: "PUT",
            token: token,
            body: faq.toHackerAPIFormat()
        }).then(function (data) { return new Faq(data); });
    };
    /**
     * Deletes a faq
     * @param event - The event whose faq to delete
     * @param event.slug
     * @param faq - The faq to delete
     * @param faq.id
     * @param user
     * @param user.token
     * @returns Doesn't resolve with a value
     */
    Faq.deleteFaq = function (_a, _b, token) {
        var slug = _a.slug;
        var id = _b.id;
        return HackerAPIFetch({
            path: "/v2/events/" + slug + "/faq/" + id,
            method: "DELETE",
            token: token
        });
    };
    return Faq;
}(Base));
export default Faq;
//# sourceMappingURL=faq.js.map